<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.paymententry') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
        <div class="col right">
          <div class="action">
            <div class="dropdown item">
              <button
                class="btn no-bg text-secondary dropdown-toggle filter"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-filter"/>
                {{ $t('message.filter') }}
                <template>
                  <span
                    v-if="query.type == 'all'"
                    class="badge badge-secondary">{{ $t('message.all') }}</span>
                  <span
                    v-if="query.type == 'pay'"
                    class="badge badge-secondary">{{ $t('message.checkboxexpense') }}</span>
                  <span
                    v-if="query.type == 'receive'"
                    class="badge badge-secondary">{{ $t('message.checkboxreceive') }}</span>
                </template>
                <template v-if="query.status !== 'all'">
                  <span
                    v-if="query.status == 'padding'"
                    class="badge badge-info">{{ $t('status.pe.unpaid') }}</span>
                  <span
                    v-if="query.status == 'paid'"
                    class="badge badge-success">{{ $t('status.pe.paid') }}</span>
                </template>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <form
                  class="px-3 py-2"
                  style="min-width: 300px;">
                  <div class="form-group">
                    <label>{{ $t('message.typeofpaymententry') }}</label>
                    <select
                      v-model="query.type"
                      class="form-control form-control-sm">
                      <option value="all">{{ $t('message.all') }}</option>
                      <option value="pay">
                        {{ $t('message.checkboxexpense') }}
                      </option>
                      <option value="receive">
                        {{ $t('message.checkboxreceive') }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group mb-0">
                    <label>{{ $t('message.status') }}</label>
                    <select
                      v-model="query.status"
                      class="form-control form-control-sm">
                      <option value="all">{{ $t('message.all') }}</option>
                      <option
                        class="text-info"
                        value="padding">
                        {{ $t('status.pe.unpaid') }}
                      </option>
                      <option
                        class="text-success"
                        value="paid">
                        {{ $t('status.pe.paid') }}
                      </option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <base-table
        v-else
        :pagination="$store.state.app.pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th style="min-width: 100px;">{{ $t('documents.pe') }}</th>
              <th class="no-sort">{{ $t('message.reference') }}</th>
              <th class="no-sort">{{ $t('message.vendor') }}/{{ $t('message.customer') }}/{{ $t('message.partner') }}</th>
              <th class="no-sort">{{ $t('message.typeofpaymententry') }}</th>
              <!-- <th class="no-sort">{{ $t('message.type') }}</th> -->
              <th>{{ $t('message.grandtotal') }}</th>
              <th>{{ $t('message.postingpaiddate') }}</th>
              <th
                class="no-sort"
                style="max-width: 100px;">{{ $t('message.status') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="payments.length === 0"
                colspan="7"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr v-for="(item, index) in payments">
              <td :data-order="item.pe_id">
                <router-link-custom
                  :to="{name: 'AccountsPaymentEntryEdit', query: {
                    pe_id: item.pe_id,
                    pe_code: item.pe_code
                  }}"
                  :text="item.pe_code"
                  :to_appid="12"
                  :current_appid="12"/>
              </td>
              <td>
                <router-link-custom
                  v-if="item.reference.payroll"
                  :to="{name: 'PaySlipEdit', query: {
                    id: item.reference.payroll.prl_id,
                    code: item.reference.payroll.prl_code
                  }}"
                  :text="item.reference.payroll.prl_code"
                  :to_appid="14"
                  :current_appid="12"/>
                <router-link-custom
                  v-if="item.reference.purchase"
                  :to="{name: 'PurchaseOrderEdit', query: {
                    id: item.reference.purchase.po_id,
                    code: item.reference.purchase.po_code
                  }}"
                  :text="item.reference.purchase.po_code"
                  :to_appid="4"
                  :current_appid="12"/>
                <router-link-custom
                  v-if="item.reference.expense"
                  :to="{name: 'ExpensesClaimEdit', query: {
                    ex_id: item.reference.expense.ex_id,
                    ex_code: item.reference.expense.ex_code
                  }}"
                  :text="item.reference.expense.ex_code"
                  :to_appid="6"
                  :current_appid="12"/>
                <router-link-custom
                  v-if="item.reference.invoice"
                  :to="{name: 'AccountsInvoiceEdit', query: {
                    in_id: item.reference.invoice.in_id,
                    in_code: item.reference.invoice.in_code
                  }}"
                  :text="item.reference.invoice.in_code"
                  :to_appid="12"
                  :current_appid="12"/>
              </td>
              <td>
                <template>
                  <router-link-custom
                    v-if="item.partner.vendor"
                    :to="{name: 'ContactVendorEdit', query: {ven_id: item.partner.vendor.vendor_id, ven_name: item.partner.vendor.vendor_name}}"
                    :text="item.partner.vendor.vendor_name"
                    :to_appid="11"
                    :current_appid="12" />
                  <router-link-custom
                    v-if="item.partner.customer"
                    :to="{name: 'ContactCustomerEdit', query: {cus_id: item.partner.customer.customer_id, cus_name: item.partner.customer.customer_name}}"
                    :text="item.partner.customer.customer_name"
                    :to_appid="11"
                    :current_appid="12" />
                </template>
              </td>
              <td>
                <template>
                  <span v-if="item.type == 'pay'">
                    {{ $t('message.checkboxexpense') }}
                  </span>
                  <span v-else>
                    {{ $t('message.checkboxreceive') }}
                  </span>
                </template>
              </td>
              <!-- <td>
                <template>
                  <span v-if="item.payment.type == 'cash'">
                    {{ $t('message.cash') }}
                  </span>
                  <span v-else-if="item.payment.type == 'card'">
                    {{ $t('message.creditcard') }}
                  </span>
                </template>
              </td> -->
              <td :data-order="item.payment.amount">
                {{ getNumber(item.payment.amount) }}
              </td>
              <td :data-order="item.created_at">
                {{ getDate(item.created_at) }}
              </td>
              <td style="max-width: 100px;">
                <template>
                  <span
                    v-if="getPaymentStatus(item, $t).status == 'completed'"
                    class="text-success">
                    {{ getPaymentStatus(item, $t).message }}
                  </span>
                  <span
                    v-else-if="getPaymentStatus(item, $t).status == 'uncompleted'"
                    class="text-info">
                    {{ getPaymentStatus(item, $t).message }}
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'AccountsPaymentEntryAll',
  mixins: [userPermissionMixin],
  data () {
    return {
      ready: false,
      query: {
        page: this.$route.query.page || 1,
        type: this.$route.query.type || 'all',
        status: this.$route.query.status || 'all',
      },
    }
  },
  computed: {
    ...mapGetters({
      payments: 'getPayments',
      getPaymentStatus: 'getPaymentStatus',
      getPurchaseStatus: 'getPurchaseStatus',
      getExpenseStatus: 'getExpenseStatus',
      getInvoiceStatus: 'getInvoiceStatus',
    }),
  },
  watch: {
    ready () {
      if (this.ready == true) {
        this.showFinish(this.$Progress)
      }
    },
    'query.type': {
      handler: function () {
        if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
          $('button.filter').dropdown('toggle')
        }
        this.fetchData()
      },
      deep: true,
    },
    'query.status': {
      handler: function () {
        if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
          $('button.filter').dropdown('toggle')
        }
        this.fetchData()
      },
      deep: true,
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = 1
        this.query.type = 'all'
        this.query.status = 'all'
        this.fetchData()
      }
    },
  },
  created () {
    this.fetchData()
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 3,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
      submenuAtIdx: 0,
    })
  },
  destroyed: function () {
    this.leavePage(this.$Progress, [])
  },
  methods: {
    async fetchData () {
      this.updateUrl()
      this.ready = false
      await this.$store.dispatch('getPayments', {
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        type: (() => {
          return this.query.type !== 'all'
            ? this.query.type
            : null
        })(),
        status: (() => {
          return this.query.status !== 'all'
            ? this.query.status
            : null
        })(),
      })
      this.ready = true
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.fetchData()
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.dropdown > button {
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/accounts/paymententry/All.vue